/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@Thread-Magic/jasmine';
import { FiPlus } from 'react-icons/fi';

import InfoCard from 'src/components/InfoCard';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import IntentArgument from '../IntentArgument';

import { IntentBlock } from './style';

const VariationArguments = ({
  variationArguments,
  handleRemoveArgument,
  handleAddFormField,
  handleChangeFormField,
  handleChangeArgumentOrder
}) => {
  const onDragStart = () => {
    // When dragging starts, disable smooth scrolling
    document.documentElement.setAttribute('style', 'scroll-behavior: auto');
  };

  const onDragEnd = result => {
    document.documentElement.removeAttribute('style');
    if (result.destination) {
      handleChangeArgumentOrder(result.source.index, result.destination.index);
    }
  };

  const sortedArguments = useMemo(() => {
    return variationArguments.sort((a, b) => a.order - b.order);
  }, [variationArguments]);

  return (
    <IntentBlock>
      <div>
        <InfoCard>This is the information the Agent will collect from the contact.</InfoCard>
        <p>Form</p>
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
          <Droppable droppableId="droppable" direction="vertical">
            {provided => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {sortedArguments?.map((item, index) => {
                  return (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {dragProvided => (
                        <IntentArgument
                          onRemove={() => handleRemoveArgument(item.id)}
                          data={item}
                          onChange={newdata => handleChangeFormField(newdata)}
                          innerRef={dragProvided.innerRef}
                          dragHandleProps={dragProvided.dragHandleProps}
                          {...dragProvided.draggableProps}
                        />
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <Button onClick={() => handleAddFormField()} type="button">
          <FiPlus />
          Add form field
        </Button>
      </div>
    </IntentBlock>
  );
};

VariationArguments.propTypes = {
  variationArguments: PropTypes.objectOf(PropTypes.any),
  handleRemoveArgument: PropTypes.func,
  handleChangeFormField: PropTypes.func,
  handleAddFormField: PropTypes.func,
  handleChangeArgumentOrder: PropTypes.func
};

VariationArguments.defaultProps = {
  variationArguments: [],
  handleChangeFormField: () => {},
  handleRemoveArgument: () => {},
  handleAddFormField: () => {},
  handleChangeArgumentOrder: () => {}
};

export default VariationArguments;
